import React from "react"
import LoginHome from "../components/Login/LoginHome"

const LoginView = () => <LoginHome />

export default LoginView
